import { Spinner } from "react-ui";
import React from "react";

interface ModalLoaderProps {
    loading: boolean;
    children: React.ReactElement;
}

export const ModalLoader = ({ children, loading }: ModalLoaderProps) =>
    loading ? <Spinner style={{ margin: "0 auto", width: "100%" }} type="normal" caption="Загрузка..." /> : children;
